import React from 'react';
import moment from 'moment';
import global from '../../../../common/utility/global';
import { FORMAT_2DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import { Table, Empty, Button, Input, Form, Select, DatePicker, Icon } from 'antd';
const { Option } = Select;

export default function Detalle(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Button
                                        type="danger"
                                        icon="delete"
                                        size={"small"}
                                        onClick={() => props.onRemove(value)}
                                    />
                                </div>
                            </span>
                        )
                    },



                    {
                        title: 'Unidad de Medida Base',
                        dataIndex: 'unidadMedida',
                        key: 'unidadMedida',
                        align: 'center',
                        width: '150px',
                        render: (value, row) => (<span class> {props.unidadMedida}</span>)
                    },
                    {
                        title: 'Cantidad Base',
                        dataIndex: 'cantidadBase',
                        key: 'cantidadBase',
                        align: 'center',
                        width: '180px',
                        // className:'hide',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`cantidadBase[${row.identifier}]`, {
                                        initialValue: parseFloat(1).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Cantidad debe ser mayor a 0"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            placeholder="Ingresar Cantidad"
                                            autoComplete="off"
                                            disabled
                                            onBlur={(e) => row.cantidadBase.toFixed(2)}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Unida de Medida',
                        dataIndex: 'idUnidadMedida',
                        key: 'idUnidadMedida',
                        width: '220px',
                        //className:'hide',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`idUnidadMedida[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onChange'],
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Cuenta"}
                                            optionFilterProp="children"
                                        >
                                            {
                                                props.formValues.unidadesMedida.map(item => (
                                                    props.formValues.nombreUnidadMedida != item.nombre ?
                                                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                        : null
                                                ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        width: '180px',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`cantidad[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Cantidad debe ser mayor a 0"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            placeholder="Ingresar Cantidad"
                                            autoComplete="off"
                                            onBlur={(e) => row.cantidad.toFixed(2)}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                ]}
            />
        </div>
    );
}